"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { createContext, useContext } from "react";
import type { AnimationState } from "@/hooks/use-animation-state";
import { useAnimationState } from "@/hooks/use-animation-state";
export interface AnimationContextType {
  animationStates: AnimationState;
  setAnimationComplete: (animationType: keyof AnimationState) => void;
  resetAnimations: () => void;
  resetTypewriterAnimation: () => void;
  resetLoadingAnimation: () => void;
  animationRefs: {
    typewriter: boolean;
    hero: boolean;
    scroll: boolean;
    loading: boolean;
  };
}
const AnimationContext = createContext<AnimationContextType | undefined>(undefined);
export const useAnimationContext = () => {
  const context = useContext(AnimationContext);
  if (typeof context === "undefined") {
    throw new Error("useAnimationContext must be used within an AnimationContextProvider");
  }
  return context;
};
export const AnimationContextProvider = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    animationRefs,
    animationStates,
    resetAnimations,
    resetLoadingAnimation,
    resetTypewriterAnimation,
    setAnimationComplete
  } = useAnimationState();
  let t1;
  if ($[0] !== animationRefs.current || $[1] !== animationStates || $[2] !== resetAnimations || $[3] !== resetLoadingAnimation || $[4] !== resetTypewriterAnimation || $[5] !== setAnimationComplete) {
    t1 = {
      animationRefs: animationRefs.current,
      animationStates,
      resetAnimations,
      resetLoadingAnimation,
      resetTypewriterAnimation,
      setAnimationComplete
    };
    $[0] = animationRefs.current;
    $[1] = animationStates;
    $[2] = resetAnimations;
    $[3] = resetLoadingAnimation;
    $[4] = resetTypewriterAnimation;
    $[5] = setAnimationComplete;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children || $[8] !== t1) {
    t2 = <AnimationContext.Provider value={t1}>{children}</AnimationContext.Provider>;
    $[7] = children;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};